import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// CONTEXT
import { useAuth } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedRoute";

// COMPONENTS
import Sidebar from "./Components/Sidebar";


// PAGES

import About from "./Components/Home/About";
import Contact from "./Components/Home/Contact";
import FAQ from "./Components/Home/FAQ";
import HomePage from "./Components/Home/HomePage";

import Login from "./Components/Login";
import Register from "./Components/Register";

import Dashboard from "./Components/Dashboard";


import ApplyLoan from "./Components/Borrower/ApplyLoan";
import LoanHistory from "./Components/Borrower/LoanHistory";
import Repayment from "./Components/Borrower/Repayment";
import PaymentAllocationHistory from "./Components/Borrower/PaymentAllocationHistory";
import Profile from "./Components/Borrower/Profile";
import LoanProducts from "./Components/Borrower/LoanProducts";


import AdminDashboard from "./Components/Admin/AdminDashboard";
import ManageUsers from "./Components/Admin/ManageUsers";
import ManageLoans from "./Components/Admin/ManageLoans";
import Approvals from "./Components/Admin/Approvals";
import Reports from "./Components/Admin/Reports";
import LoanProduct from "./Components/Admin/LoanProduct";
import MakePayment from "./Components/Admin/MakePayment";
import AddLoans from "./Components/Admin/AddLoans";


import LoanApplications from "./Components/Borrower/LoanApplication";
import Notifications from "./Components/Admin/Notifications";
import LoanPayment from "./Components/Admin/LoanPayment";

function App() {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated);
  const [isAdminUser, setIsAdminUser] = useState(isAdmin);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Update local state when context changes
  React.useEffect(() => {
    setIsLoggedIn(isAuthenticated);
    setIsAdminUser(isAdmin);
  }, [isAuthenticated, isAdmin]);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Calculate page margin based on sidebar state
  const getPageMargin = () => {
    return isSidebarCollapsed ? '80px' : '260px';
  };

  return (
    <div className="app-container">
      {/* SIDEBAR */}
      <Sidebar
        isLoggedIn={isLoggedIn}
        isAdmin={isAdminUser}
        onCollapseChange={setIsSidebarCollapsed}
      />

      {/* PAGE CONTENT - Dynamic margin based on sidebar state */}
      <div className="page-content" style={{ marginLeft: getPageMargin() }}>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to={isAdmin ? "/admin/dashboard" : "/dashboard"} />
              ) : (
                <Login setIsLoggedIn={setIsLoggedIn} setIsAdmin={setIsAdminUser} />
              )
            }
          />
          <Route path="/register" element={<Register />} />

          {/* BORROWER/USER PROTECTED ROUTES */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/loan-products"
            element={
              <ProtectedRoute>
                <LoanProducts />
              </ProtectedRoute>
            }
          />

          
          <Route
            path="/apply-loan"
            element={
              <ProtectedRoute>
                <ApplyLoan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/loan-history"
            element={
              <ProtectedRoute>
                <LoanHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/repayment"
            element={
              <ProtectedRoute>
                <Repayment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-allocation-history"
            element={
              <ProtectedRoute>
                <PaymentAllocationHistory />
              </ProtectedRoute>
            }
          />
            <Route
            path="/loan-applications"
            element={
              <ProtectedRoute>
                <LoanApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          {/* ADMIN PROTECTED ROUTES */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                {isAdmin ? <AdminDashboard /> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                {isAdmin ? <ManageUsers /> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/loans"
            element={
              <ProtectedRoute>
                {isAdmin ? <ManageLoans /> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />
           <Route
            path="/admin/addLoans"
            element={
              <ProtectedRoute>
                {isAdmin ? <AddLoans/> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />

        
          <Route
            path="/admin/approvals"
            element={
              <ProtectedRoute>
                {isAdmin ? <Approvals /> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />

           <Route
            path="/admin/makePayments"
            element={
              <ProtectedRoute>
                {isAdmin ? <MakePayment /> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />
        
          <Route
            path="/admin/loanPayments"
            element={
              <ProtectedRoute>
                {isAdmin ? <LoanPayment/> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/loanProducts"
            element={
              <ProtectedRoute>
                {isAdmin ? <LoanProduct/> : <Navigate to="/dashboard" />}
              </ProtectedRoute>
            }
          />

          {/* FALLBACK ROUTE */}
          <Route
            path="*"
            element={
              <h2 style={{ textAlign: "center", marginTop: "50px" }}>
                Page Not Found
              </h2>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;


